import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import { auth } from "../firebase";

Vue.use(VueRouter);

const routes = [
  // {
  //   path: "/",
  //   name: "Home",
  //   component: Home,
  // },
  {
    path: "/concurso",
    name: "Contest",
    component: () => import("../views/Contest.vue"),
  },
  {
    path: "/premio",
    name: "Price",
    component: () => import("../views/Price.vue"),
  },
  {
    path: "/jurado",
    name: "Juries",
    component: () => import("../views/Juries.vue"),
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/registro-exitoso",
    name: "CorrectRegister",
    component: () => import("../views/CorrectRegister.vue"),
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: () => import("../views/Dashboard.vue"),
    meta: {
      requiresAuth: true,
      admins: true,
    },
  },
  {
    path: "/emprendimiento/:uid",
    name: "Emprendimiento",
    component: () => import("../views/Emprendimiento.vue"),
    meta: {
      requiresAuth: true,
      admins: true,
    },
  },
  {
    path: "/lanzamiento",
    name: "Lanzamiento",
    component: () => import("../views/Lanzamiento.vue"),
  },
  {
    path: "/emprendimientos",
    name: "Emprendimientos",
    component: () => import("../views/Emprendimientos.vue"),
  },
  {
    path: "/",
    name: "Capitulos",
    component: () => import("../views/Capitulos.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});

router.beforeEach(async (to, from, next) => {
  let { currentUser } = auth;
  var isAdmin;

  if (currentUser !== null) {
    const token = await currentUser.getIdTokenResult();
    isAdmin = token.claims.admin;
  }

  const requiresAuth = to.matched.some((x) => x.meta.requiresAuth);

  if (!currentUser && requiresAuth) {
    next("/login");
  } else {
    next();
  }

  const admins = to.matched.some((x) => x.meta.admins);
  if (!isAdmin && admins) {
    next("/login");
  } else {
    next();
  }
});

export default router;
